module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Cloudy-night-df5a479ee48fd6703b16c8d29d008cfa.svg";